import { useState } from 'react';

interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-black/80'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://static.readdy.ai/image/ac89004c0dc4ecdcf411495653d0d9a7/f9faacd40ba94040d63ca5a9983e5de2.jpeg"
              alt="Monarch Xpress LLC"
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('fleet')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              Fleet
            </button>
            <button
              onClick={() => scrollToSection('coverage')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              Coverage
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-green-600' : 'text-white hover:text-green-400'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('recruiting')}
              className="bg-green-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join Our Team
            </button>
          </div>

          <button
            className="lg:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3">
            <button
              onClick={() => scrollToSection('services')}
              className={`block w-full text-left py-2 text-sm font-medium cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('fleet')}
              className={`block w-full text-left py-2 text-sm font-medium cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Fleet
            </button>
            <button
              onClick={() => scrollToSection('coverage')}
              className={`block w-full text-left py-2 text-sm font-medium cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Coverage
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`block w-full text-left py-2 text-sm font-medium cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`block w-full text-left py-2 text-sm font-medium cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('recruiting')}
              className="bg-green-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-green-700 transition-colors w-full whitespace-nowrap cursor-pointer"
            >
              Join Our Team
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}